import.meta.glob(['../images/**', '../fonts/**']);

import App from './App.ts';

window.addEventListener('DOMContentLoaded', () => {
  new App();
});
